// ClientDetail/Components/Invoices/Invoices.jsx
import React from 'react';
import Classes from './Invoices.module.css';
import RecordTable from './RecordTable/RecordTable';

export default function Invoices({ loading, invoices = [], userId }) {
  return (
    <div className={Classes.hero}>
      <RecordTable loading={loading} invoices={invoices} userId={userId} />
    </div>
  );
}
